"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var AppPaySystemTransactionLists_1 = require("./component/AppPaySystemTransactionLists");
var PAppPaySystemTransactionsList = /** @class */ (function (_super) {
    __extends(PAppPaySystemTransactionsList, _super);
    function PAppPaySystemTransactionsList(props) {
        return _super.call(this, props) || this;
    }
    PAppPaySystemTransactionsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.servicesData.Subscribe("*", function (id, data) {
            _this.setState({ avail_services: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                services_list: data.services_list,
                all_services: data.all_services,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            services_list: this.props.state.getServicesList(),
            all_services: this.props.state.getIsAllServices(),
            avail_services: [],
        }, function () {
            _this.props.servicesData.LoadData();
        });
    };
    PAppPaySystemTransactionsList.prototype.componentWillUnmount = function () {
        this.props.servicesData.UnSubscribe(this.SID_AB);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PAppPaySystemTransactionsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PAppPaySystemTransactionsList.prototype.onServiceFilterChanged = function (allServices, ServiceId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllServices(allServices, true);
        }
        if (Action === "add") {
            this.props.state.addService(ServiceId, true);
        }
        if (Action === "remove") {
            this.props.state.delService(ServiceId, true);
        }
    };
    PAppPaySystemTransactionsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(AppPaySystemTransactionLists_1.default, { data: this.props.data, state: this.props.state, onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, servicesList: this.state.services_list, allServices: this.state.all_services, availServices: this.state.avail_services, onServiceFilterChanged: this.onServiceFilterChanged.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PAppPaySystemTransactionsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PAppPaySystemTransactionsList.getPageDescription = function (state) {
        return {
            icon: "money-check-alt",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_paysystem_transactions + "-id",
            itemTitle: "Транзакции",
            route: routes_1.routes.page_paysystem_transactions,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PAppPaySystemTransactionsList;
}(React.Component));
exports.default = PAppPaySystemTransactionsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem_transactions/ui/PAppPaySystemTransactionsList.tsx
// module id = 2573
// module chunks = 0